var map = {
	"./childbirth.vue": "./src/views/remind/childbirth.vue",
	"./prenatal.vue": "./src/views/remind/prenatal.vue",
	"./vaccine.vue": "./src/views/remind/vaccine.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views/remind sync \\.vue$";